import { render, staticRenderFns } from "./Qoshimcha.vue?vue&type=template&id=c87ae6ae"
import script from "./Qoshimcha.vue?vue&type=script&lang=js"
export * from "./Qoshimcha.vue?vue&type=script&lang=js"
import style0 from "./Qoshimcha.vue?vue&type=style&index=0&id=c87ae6ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports